import React from 'react';
import { motion } from 'motion/react';
import { EASE_OUT } from './tokens';
import usePrefersReducedMotion from './usePrefersReducedMotion';

function ShimmerBar({ className = '', delay = 0 }) {
  const reduced = usePrefersReducedMotion();

  if (reduced) {
    return <div className={`rounded-lg bg-gray-200/80 ${className}`.trim()} />;
  }

  return (
    <motion.div
      className={`relative overflow-hidden rounded-lg bg-gray-200/70 ${className}`.trim()}
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, delay, ease: EASE_OUT }}
    >
      <motion.span
        className="absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent"
        initial={{ x: '-100%' }}
        animate={{ x: '100%' }}
        transition={{
          duration: 1.15,
          delay: delay + 0.15,
          repeat: Infinity,
          ease: 'linear',
        }}
        aria-hidden="true"
      />
    </motion.div>
  );
}

export default function WelcomeLoading() {
  const reduced = usePrefersReducedMotion();

  return (
    <motion.div
      className="space-y-3 pt-1"
      initial={reduced ? false : { opacity: 0, y: 6 }}
      animate={{ opacity: 1, y: 0 }}
      exit={reduced ? undefined : { opacity: 0, y: -6, filter: 'blur(4px)' }}
      transition={{ duration: reduced ? 0 : 0.22, ease: EASE_OUT }}
      role="status"
      aria-live="polite"
      aria-label="Loading welcome"
    >
      <ShimmerBar className="h-9 sm:h-11 w-[min(28rem,90%)]" delay={0} />
      <ShimmerBar className="h-5 w-[min(22rem,70%)]" delay={0.08} />
      <motion.p
        className="text-sm font-medium text-teal-700/90"
        initial={reduced ? false : { opacity: 0 }}
        animate={reduced ? { opacity: 1 } : { opacity: [0.4, 1, 0.4] }}
        transition={
          reduced ? undefined : { duration: 1.4, repeat: Infinity, ease: 'easeInOut' }
        }
      >
        Preparing your workspace…
      </motion.p>
    </motion.div>
  );
}
